import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { useParams } from 'react-router-dom';
import { MessageBar, MessageBarType, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import styles from './ContractStatements.style';
import StatementList from '../../components/StatementList';
import { fetchStatements, fetchAttachment, fetchPayGoAttachment } from '../../actions/statements';
import useAPI from '../../hooks/useAPI';

const ContractStatements = () => {
  const dispatch = useDispatch();
  const { contractAddress } = useParams();
  const statements = useSelector(state =>
    Object.values(get(state, `entities.statements`, {})).filter(
      statement => statement.contract.address === contractAddress,
    ),
  );

  const { isLoading } = useAPI(() => fetchStatements({ contractAddress }));

  const onDownload = async downloadUrls => {
    const statementUrl = get(downloadUrls, 'excelFileUrl');
    const payGoStatementUrl = get(downloadUrls, 'payGoExcelFileUrl');
    if (statementUrl) {
      await dispatch(fetchAttachment(statementUrl));
    }
    if (payGoStatementUrl) {
      await dispatch(fetchPayGoAttachment(payGoStatementUrl));
    }
  };

  return (
    <>
      {isLoading && (
        <Spinner
          size={SpinnerSize.medium}
          className={styles.loadingSpinner}
          data-testid="statementSpinner"
        />
      )}
      {!isLoading && (!statements || statements.length === 0) && (
        <MessageBar
          messageBarType={MessageBarType.info}
          messageBarIconProps={{ iconName: 'Info' }}
          isMultiline
          dismissButtonAriaLabel="Close"
          nowrap
        >
          <Text>No Statements</Text>
          <br />
          <Text className={styles.noStatementsText}>
            Statements have not yet been processed for this contract.
          </Text>
        </MessageBar>
      )}
      {!isLoading && statements && statements.length > 0 && (
        <StatementList items={statements} onDownload={onDownload} isContractPage />
      )}
    </>
  );
};

export default ContractStatements;
